<template>
  <span :style="`padding-left: ${moveLeft}px;`"
    :class="{
      'text-success': hasHighlight,
      'font-weight-bold': hasHighlight
    }">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'IndentedSpan',
  props: {
    level: Number,
    hasHighlight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    moveLeft() {
      return this.level * 30;
    }
  }
};
</script>
